export default function themeTypography(theme: any) {
    return {
        fontFamily: theme?.customization?.fontFamily,
        h6: {
            fontWeight: 500,
            color: "var(--ion-color-light)",
            fontSize: "0.75rem",
        },
        h5: {
            fontSize: "0.875rem",
            color: "var(--ion-color-light)",
            fontWeight: 500,
        },
        h4: {
            fontSize: "1rem",
            color: "var(--ion-color-light)",
            fontWeight: 600,
        },
        h3: {
            fontSize: "1.25rem",
            color: "var(--ion-color-light)",
            fontWeight: 600,
        },
        h2: {
            fontSize: "1.5rem",
            color: "var(--ion-color-light)",
            fontWeight: 700,
        },
        h1: {
            fontSize: "2.125rem",
            color: "var(--ion-color-light)",
            fontWeight: 700,
        },
        subtitle1: {
            fontSize: "0.875rem",
            fontWeight: 500,
            color: "var(--color-white)",
        },
        subtitle2: {
            fontSize: "0.75rem",
            fontWeight: 400,
            color: "var(--ion-color-grey)",
        },
        caption: {
            fontSize: "0.75rem",
            color: "var(--ion-color-grey)",
            fontWeight: 400,
        },
        body1: {
            fontSize: "0.875rem",
            fontWeight: 400,
            lineHeight: "1.334em",
            color: "var(--color-white)",
        },
        body2: {
            letterSpacing: "0em",
            fontWeight: 400,
            lineHeight: "1.5em",
            color: "var(--color-white)",
        },
        button: {
            textTransform: "uppercase",
            fontWeight: 700,
        },

        mainContent: {
            backgroundColor: theme.background,
            width: "100%",
            height: "calc(100vh - 80px)",
            flexGrow: 1,
            padding: "20px",
            marginTop: "80px",
            overflow: "auto",
        },
        menuCaption: {
            fontSize: "0.875rem",
            fontWeight: 500,
            color: "var(--color-white)",
            padding: "6px",
            textTransform: "capitalize",
            marginTop: "10px",
        },
        subMenuCaption: {
            fontSize: "0.6875rem",
            fontWeight: 500,
            color: "var(--color-white)",
            textTransform: "capitalize",
        },
        commonAvatar: {
            cursor: "pointer",
            borderRadius: "8px",
        },
        smallAvatar: {
            width: "22px",
            height: "22px",
            fontSize: "1rem",
        },
        mediumAvatar: {
            width: "34px",
            height: "34px",
            fontSize: "1.2rem",
        },
        largeAvatar: {
            width: "44px",
            height: "44px",
            fontSize: "1.5rem",
        },
        customInput: {
            backgroundColor: "var(--ion-color-dark)",
            "& input": {
                color: "var(--color-white)",
            },
            "& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active": {
                WebkitTextFillColor: "var(--color-white)",
                caretColor: "var(--color-white)",
                WebkitBoxShadow: "0 0 0 1000px var(--ion-color-dark) inset",
                boxShadow: "0 0 0 1000px var(--ion-color-dark) inset",
                transition: "background-color 9999s ease-out 0s",
            },
            "& > label": {
                color: theme.grey500,
            },
            "& .MuiInputBase-root": {
                backgroundColor: "var(--ion-color-dark)",
            },
            "& .MuiInputBase-input": {
                backgroundColor: "unset",
            },
            "& fieldset": {
                borderColor: "var(--ion-color-grey)",
            },
        },
    };
}
